module.exports = __webpack_public_path__ + "static/media/icon-social-engagement-rate.5740662d.svg";